import { render, staticRenderFns } from "./TransactionXRPPool.vue?vue&type=template&id=ba3af2b4&scoped=true&"
import script from "./TransactionXRPPool.vue?vue&type=script&lang=js&"
export * from "./TransactionXRPPool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3af2b4",
  null
  
)

export default component.exports